import { fetchApi } from '../client';
import { buildQS } from '../helpers';
import type { PagedResponse } from '../../../types/pagination';

export type ErasureRequestStatus = 'PENDING' | 'APPROVED' | 'REJECTED';

export interface ErasureRequestResponse {
  id: string;
  patientId: string;
  patientName: string;
  requestedByType: 'PATIENT' | 'STAFF';
  requestedByName: string;
  reason: string | null;
  status: ErasureRequestStatus;
  reviewedByName: string | null;
  reviewedAt: string | null;
  reviewNotes: string | null;
  createdAt: string;
}

export const erasureModule = {
  /** Staff/admin: submit an erasure request on a patient's behalf. */
  submitByStaff: (patientId: string, reason: string) =>
    fetchApi<ErasureRequestResponse>(`/api/erasure-requests/patients/${patientId}`, {
      method: 'POST',
      body: JSON.stringify({ reason }),
    }),

  /** Staff/admin (clinic_admin/super_admin only): list requests for the active clinic. */
  list: (status?: ErasureRequestStatus) =>
    fetchApi<ErasureRequestResponse[]>(
      `/api/erasure-requests${status ? `?status=${status}` : ''}`
    ),

  /** One page of a status tab, newest first (medopd-docs 112). */
  listPage: (status: ErasureRequestStatus | undefined, page: number, size: number) =>
    fetchApi<PagedResponse<ErasureRequestResponse>>(`/api/erasure-requests${buildQS({ status, page, size })}`),

  /** Approve — reviewNotes documents how identity was verified (required). */
  approve: (id: string, reviewNotes: string) =>
    fetchApi<ErasureRequestResponse>(`/api/erasure-requests/${id}/approve`, {
      method: 'POST',
      body: JSON.stringify({ reviewNotes }),
    }),

  reject: (id: string, reviewNotes?: string) =>
    fetchApi<ErasureRequestResponse>(`/api/erasure-requests/${id}/reject`, {
      method: 'POST',
      body: JSON.stringify({ reviewNotes }),
    }),

  /** Patient portal: self-service submission for the currently-authenticated patient. */
  submitByPatient: (reason: string) =>
    fetchApi<{ id: string; status: string; message: string }>('/api/patient-portal/erasure-requests', {
      method: 'POST',
      body: JSON.stringify({ reason }),
    }),
};
